import * as React from 'react';
import { Button } from '@mc/react-core';
import classNames from 'classnames';

const ClassNameNS = 'app-button-link';
const ClassName = ` ${ClassNameNS}`;

type Props = Omit<
  React.ComponentProps<typeof Button>,
  'active' | 'fill' | 'intent' | 'outlined'
> & {
  fixedWidth?: boolean;
};

export class LinkButton extends React.PureComponent<Props> {
  render() {
    const { className, fixedWidth, ...other } = this.props;

    return (
      <Button
        className={classNames(className, ClassName, {
          [`app-button-fw`]: fixedWidth,
        })}
        {...other}
      />
    );
  }
}
